export default {"src":"/_next/static/media/pair-2.9718ee8a.svg","height":322,"width":593,"blurWidth":0,"blurHeight":0};